(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blinx-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  class BxPackBuilder extends HTMLElement {
    connectedCallback() {
      try {
        this.products = JSON.parse(this.querySelector('[data-products]').textContent).filter((product) => product.variants.length);
      } catch (err) {
        this.products = [];
      }
      this.packs = Array.from(this.querySelectorAll('[data-pack]'));
      if (!this.products.length || !this.packs.length) return;
      this.size = null;
      /* Product ids in the order they were added, one entry per unit. */
      this.picks = [];

      const sizes = [];
      this.products.forEach((product) => product.variants.forEach((variant) => {
        if (!sizes.includes(variant.size)) sizes.push(variant.size);
      }));
      const holder = this.querySelector('[data-sizes]');
      const name = 'bxb-size-' + Math.random().toString(36).slice(2, 8);
      sizes.forEach((size) => {
        const label = document.createElement('label');
        label.className = 'bxb-size';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = name;
        input.value = size;
        input.className = 'mp-visually-hidden';
        input.addEventListener('change', () => {
          this.size = size;
          holder.classList.remove('is-missing');
          /* A style that is sold out in the new size leaves the pack. */
          this.picks = this.picks.filter((id) => this.variantOf(id));
          this.update();
        });
        const text = document.createElement('span');
        text.textContent = size;
        label.appendChild(input);
        label.appendChild(text);
        holder.appendChild(label);
      });

      this.packs.forEach((input) => input.addEventListener('change', () => {
        this.picks.length = Math.min(this.picks.length, this.pack.count);
        this.update();
      }));
      this.querySelectorAll('[data-product]').forEach((card) => {
        const id = Number(card.dataset.product);
        if (!this.products.some((product) => product.id === id)) {
          card.hidden = true;
          return;
        }
        const add = () => {
          if (this.picks.length >= this.pack.count || !this.canPick(id)) return;
          this.picks.push(id);
          this.update();
        };
        card.querySelector('[data-add]').addEventListener('click', add);
        card.querySelector('[data-plus]').addEventListener('click', add);
        card.querySelector('[data-minus]').addEventListener('click', () => {
          const index = this.picks.lastIndexOf(id);
          if (index > -1) this.picks.splice(index, 1);
          this.update();
          if (!this.picks.includes(id)) card.querySelector('[data-add]').focus({ preventScroll: true });
        });
      });
      this.querySelector('[data-submit]').addEventListener('click', () => this.submit());
      this.update();
    }

    get pack() {
      const input = this.packs.find((item) => item.checked) || this.packs[0];
      return { count: Number(input.dataset.count || 1), off: Number(input.dataset.off || 0), title: input.dataset.title || '', input };
    }

    get rate() {
      const currency = window.Shopify && window.Shopify.currency;
      return currency && Number(currency.rate) > 0 ? Number(currency.rate) : 1;
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(this.dataset.locale || undefined, { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
      } catch (err) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    variantOf(id) {
      const product = this.products.find((item) => item.id === id);
      if (!product) return null;
      const size = this.size;
      const variant = size ? product.variants.find((item) => item.size === size) : product.variants.find((item) => item.available);
      return variant && variant.available ? variant : null;
    }

    canPick(id) {
      return Boolean(this.variantOf(id));
    }

    update() {
      const pack = this.pack;
      const unit = this.dataset.unitLabel || 'item';
      const base = this.products[0].variants[0].price;
      this.packs.forEach((input) => {
        const count = Number(input.dataset.count || 1);
        const off = Math.round(Number(input.dataset.off || 0) * this.rate);
        const card = input.closest('.bxb-pack');
        const price = Math.max(0, base * count - off);
        card.querySelector('[data-pack-price]').textContent = this.money(price);
        const compare = card.querySelector('[data-pack-compare]');
        compare.hidden = off <= 0;
        compare.textContent = this.money(base * count);
        card.querySelector('[data-pack-unit]').textContent = this.money(Math.round(price / count)) + ' / ' + unit;
      });

      const full = this.picks.length >= pack.count;
      this.querySelectorAll('[data-product]').forEach((card) => {
        const id = Number(card.dataset.product);
        const qty = this.picks.filter((pick) => pick === id).length;
        const possible = this.canPick(id);
        card.classList.toggle('is-picked', qty > 0);
        card.classList.toggle('is-out', !possible);
        const add = card.querySelector('[data-add]');
        const stepper = card.querySelector('[data-stepper]');
        add.hidden = qty > 0;
        stepper.hidden = qty === 0;
        add.disabled = !possible || full;
        if (!add.dataset.label) add.dataset.label = add.textContent;
        add.textContent = possible ? add.dataset.label : 'Sold out' + (this.size ? ' in ' + this.size : '');
        card.querySelector('[data-qty]').textContent = String(qty);
        card.querySelector('[data-plus]').disabled = !possible || full;
        const badge = card.querySelector('[data-badge]');
        badge.hidden = qty === 0;
        badge.textContent = '×' + qty;
      });

      const slots = this.querySelector('[data-slots]');
      slots.textContent = '';
      for (let i = 0; i < pack.count; i += 1) {
        const slot = document.createElement('span');
        slot.className = 'bxb-slot';
        const product = this.products.find((item) => item.id === this.picks[i]);
        if (product) {
          slot.classList.add('is-filled');
          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = '';
            slot.appendChild(image);
          }
        }
        slots.appendChild(slot);
      }

      const chosen = this.picks.map((id) => this.variantOf(id)).filter(Boolean);
      const sum = chosen.reduce((total, variant) => total + variant.price, 0);
      const off = full ? Math.round(pack.off * this.rate) : 0;
      const left = pack.count - this.picks.length;
      this.querySelector('[data-count-text]').textContent = this.picks.length + ' of ' + pack.count;
      const status = this.querySelector('[data-status]');
      if (!this.size) status.textContent = 'Choose your size to start';
      else if (left > 0) status.textContent = 'Add ' + left + ' more to unlock the pack price';
      else status.textContent = pack.title + ', size ' + this.size;
      this.querySelector('[data-total]').textContent = this.money(full ? Math.max(0, sum - off) : Math.max(0, base * pack.count - Math.round(pack.off * this.rate)));
      const compare = this.querySelector('[data-compare]');
      compare.hidden = pack.off <= 0;
      compare.textContent = this.money(base * pack.count);
      const submit = this.querySelector('[data-submit]');
      submit.disabled = !(full && this.size);
      const error = this.querySelector('[data-error]');
      if (full && this.size) error.hidden = true;
    }

    async openCartDrawer() {
      try {
        const wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (!wrapper || !document.getElementById('cart-drawer')) return false;
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(root + '?sections=cart-drawer-section');
        if (!response.ok) return false;
        const html = (await response.json())['cart-drawer-section'];
        if (!html) return false;
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-cart-drawer-section');
        if (!fresh || !fresh.querySelector('#cart-drawer')) return false;
        wrapper.innerHTML = fresh.innerHTML;
        await customElements.whenDefined('theme-drawer');
        const drawer = document.getElementById('cart-drawer');
        if (!drawer || typeof drawer.open !== 'function') return false;
        drawer.open();
        return true;
      } catch (err) {
        return false;
      }
    }

    async submit() {
      const pack = this.pack;
      const error = this.querySelector('[data-error]');
      error.hidden = true;
      if (!this.size) {
        this.querySelector('[data-sizes]').classList.add('is-missing');
        error.textContent = 'Choose your size first.';
        error.hidden = false;
        return;
      }
      const variants = this.picks.map((id) => this.variantOf(id));
      if (variants.length < pack.count || variants.some((variant) => !variant)) return;
      const quantities = new Map();
      variants.forEach((variant) => quantities.set(variant.id, (quantities.get(variant.id) || 0) + 1));
      const items = Array.from(quantities, ([id, quantity]) => ({ id, quantity, properties: { _bundle: pack.title } }));
      const submit = this.querySelector('[data-submit]');
      submit.disabled = true;
      const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers, body: JSON.stringify({ items }) });
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Could not add to cart');
        }
        if (this.dataset.afterAdd === 'drawer' && (await this.openCartDrawer())) {
          submit.disabled = false;
          return;
        }
        window.location.href = this.dataset.cartUrl || '/cart';
      } catch (err) {
        error.textContent = err.message;
        error.hidden = false;
        submit.disabled = false;
      }
    }
  }

  if (!customElements.get('bx-pack-builder')) customElements.define('bx-pack-builder', BxPackBuilder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blinx-product"] && !Shopify.designMode) return;
  try {
    
  /* Size logic, kept free of the DOM so it can be tested on its own. */
  const BxFit = {
    IN: 2.54,
    LB: 0.45359237,

    /* "XXL" and "2XL" are the same size. */
    norm(label) {
      let text = String(label == null ? '' : label).trim().toUpperCase().replace(/\s+/g, '');
      const match = text.match(/^(X{2,})([SL])$/);
      if (match) text = match[1].length + 'X' + match[2];
      return text;
    },

    num(raw) {
      const text = String(raw == null ? '' : raw).trim().replace(',', '.');
      if (!/^\d+(\.\d+)?$/.test(text)) return NaN;
      return parseFloat(text);
    },

    list(raw) {
      return String(raw || '').split(',').map((part) => parseFloat(part)).filter((value) => !Number.isNaN(value));
    },

    range(raw) {
      const text = String(raw || '').replace(/[–—]/g, '-').replace(/\s+/g, '');
      let match = text.match(/^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)$/);
      if (match) return [parseFloat(match[1]), parseFloat(match[2])];
      match = text.match(/^(\d+(?:\.\d+)?)\+$/);
      if (match) return [parseFloat(match[1]), Infinity];
      return null;
    },

    /* One row per line: "Size | min-max | min-max (optional second measurement) | US size (optional)". */
    parseTable(raw, sizes) {
      const known = (sizes || []).map((size) => BxFit.norm(size));
      const rows = [];
      String(raw || '').split('\n').forEach((line) => {
        const parts = line.split('|').map((part) => part.trim());
        if (parts.length < 2 || !parts[0]) return;
        const a = BxFit.range(parts[1]);
        if (!a) return;
        const row = { label: parts[0], key: BxFit.norm(parts[0]), a, b: null, us: '' };
        /* A part starting with a letter ("US 4-6") is the usual clothing size, shown in the chart only. */
        parts.slice(2).forEach((part) => {
          if (!part) return;
          if (/^[a-z]/i.test(part)) row.us = part.replace(/^us\s*/i, '');
          else if (!row.b) row.b = BxFit.range(part);
        });
        if (known.length) {
          const index = known.indexOf(row.key);
          if (index < 0) return;
          row.label = sizes[index];
        }
        rows.push(row);
      });
      return rows;
    },

    /* Reads a body length. Works out the unit when the number can only be the other one. */
    readLength(raw, unit) {
      const value = BxFit.num(raw);
      if (Number.isNaN(value)) return { error: 'empty' };
      const okIn = value >= 18 && value <= 80;
      const okCm = value >= 46 && value <= 203;
      let used = unit;
      if (unit === 'in' && !okIn) used = okCm ? 'cm' : null;
      if (unit === 'cm' && !okCm) used = okIn ? 'in' : null;
      if (!used) return { error: 'range' };
      const inches = used === 'in' ? value : value / BxFit.IN;
      return { in: inches, cm: inches * BxFit.IN, unit: used, switched: used !== unit, typed: value };
    },

    readWeight(raw, unit) {
      const value = BxFit.num(raw);
      if (Number.isNaN(value)) return { error: 'empty' };
      const okLb = value >= 70 && value <= 500;
      const okKg = value >= 32 && value <= 227;
      let used = unit;
      if (unit === 'lb' && !okLb) used = okKg ? 'kg' : null;
      if (unit === 'kg' && !okKg) used = okLb ? 'lb' : null;
      if (!used) return { error: 'range' };
      const lb = used === 'lb' ? value : value / BxFit.LB;
      return { lb, kg: lb * BxFit.LB, unit: used, switched: used !== unit, typed: value };
    },

    /* A length in the unit the table is written in. Converted values snap to the nearest half unit,
       so 69 cm on an inch table reads as 27 in, the same row the cm version of the chart shows. */
    native(length, tableUnit) {
      if (length.unit === tableUnit) return length.typed;
      const value = tableUnit === 'in' ? length.in : length.cm;
      return Math.round(value * 2) / 2;
    },

    /* Finds the row for one measurement. Never rounds down:
       - on a line shared by two sizes, the larger size wins;
       - in a gap between two rows, the next size up wins. */
    pick(rows, key, value) {
      const last = rows.length - 1;
      if (value < rows[0][key][0]) return { index: 0, status: 'below' };
      if (value > rows[last][key][1]) return { index: last, status: 'above' };
      for (let i = 0; i <= last; i += 1) {
        const min = rows[i][key][0];
        const max = rows[i][key][1];
        if (value >= min && value < max) return { index: i, status: 'in', position: max === Infinity ? 0 : (value - min) / (max - min) };
        if (value === max) {
          for (let j = i + 1; j <= last; j += 1) {
            if (rows[j][key][0] === max && rows[j][key][1] !== max) return { index: j, status: 'edge', lower: i, position: 0 };
          }
          return { index: i, status: 'in', position: 1 };
        }
      }
      for (let i = 0; i <= last; i += 1) {
        if (rows[i][key][0] > value) return { index: i, status: 'between', lower: i - 1, position: 0 };
      }
      return { index: last, status: 'above' };
    },

    /* Chart with one or two measurements. The larger of the two results wins. */
    fromChart(rows, a, b) {
      const first = BxFit.pick(rows, 'a', a);
      const useB = b != null && rows.every((row) => row.b);
      const second = useB ? BxFit.pick(rows, 'b', b) : null;
      if (first.status === 'above' || (second && second.status === 'above')) {
        return { status: 'above', index: rows.length - 1, driver: first.status === 'above' ? 'a' : 'b', first, second };
      }
      let driver = 'a';
      let chosen = first;
      if (second && second.index > first.index) {
        driver = 'b';
        chosen = second;
      }
      return { status: chosen.status, index: chosen.index, lower: chosen.lower, position: chosen.position, driver, first, second, raised: driver === 'b' };
    },

    /* Height and weight give the base size. A bust measurement can only move it up, never down. */
    fromBody(config, heightIn, lb, bustIn) {
      const weights = config.weights;
      let base = 0;
      while (base < weights.length && lb > weights[base]) base += 1;
      const tall = config.tall;
      if (tall.length === 2 && heightIn >= tall[0] && base <= tall[1]) base += 1;
      let index = base;
      let bustIndex = null;
      if (bustIn != null) {
        bustIndex = 0;
        while (bustIndex < config.bust.length && bustIn >= config.bust[bustIndex]) bustIndex += 1;
        index = Math.max(base, bustIndex);
      }
      const last = config.sizes.length - 1;
      const capped = index > last;
      if (capped) index = last;
      const far = index === last && ((bustIn != null && config.bust.length && bustIn >= config.bust[config.bust.length - 1] + 3) || lb > weights[weights.length - 1] + 40);
      return { status: 'in', index, base, bustIndex, raised: bustIndex != null && bustIndex > base, top: capped || far };
    },
  };

  class BxBuyBox extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-form]');
      if (!this.form) return;
      const read = (selector, fallback) => {
        try {
          return JSON.parse(this.querySelector(selector).textContent);
        } catch (err) {
          return fallback;
        }
      };
      this.variants = read('[data-variants]', []);
      this.optionNames = read('[data-option-names]', []);
      this.swatches = this.parseSwatches(read('[data-swatch-map]', ''));
      this.colorPosition = Number(this.dataset.colorPosition || 0);
      this.sizePosition = Number(this.dataset.sizePosition || 0);
      this.variantInput = this.querySelector('[data-variant-input]');
      this.tiers = Array.from(this.querySelectorAll('[data-tier]'));
      this.submitButtons = Array.from(this.querySelectorAll('[data-submit]'));
      this.unitsEl = this.querySelector('[data-units]');
      /* Mix and match: each item of a bundle can be another style of the same type. */
      this.handle = this.dataset.handle || '';
      this.pool = {};
      read('[data-mix]', []).forEach((item) => {
        if (item && item.handle && Array.isArray(item.variants) && item.variants.length) this.pool[item.handle] = item;
      });
      const ownImage = this.querySelector('[data-gallery] img');
      if (!this.pool[this.handle]) this.pool[this.handle] = { handle: this.handle, title: this.dataset.title || '', image: '', variants: this.variants };
      this.pool[this.handle].variants = this.variants;
      if (!this.pool[this.handle].image && ownImage) this.pool[this.handle].image = (ownImage.currentSrc || ownImage.src || '');
      this.mixOn = Object.keys(this.pool).length > 1;
      /* With bundles, every item gets its own color and size row inside the selected bundle card. */
      this.inline = this.tiers.length > 0 && this.optionNames.length > 0 && !(this.optionNames.length === 1 && this.optionNames[0] === 'Title');
      /* Without bundles, units[0] mirrors the main pickers. */
      this.units = [this.inline ? this.blankUnit() : this.readMainOptions()];
      this.touched = [true];

      this.paintSwatches(this);
      this.tiers.forEach((input) => input.addEventListener('change', () => this.update()));
      this.querySelectorAll('[data-option-input]').forEach((input) => {
        input.addEventListener('change', () => {
          this.units[0] = this.readMainOptions();
          this.update(true);
        });
      });
      this.form.addEventListener('submit', (event) => this.onSubmit(event));

      this.initFit();
      this.update();
      this.initGallery();
      this.initZoom();
      this.initSticky();
      this.initShipDate();
      this.initCountdown();
    }

    parseSwatches(raw) {
      const map = {};
      String(raw || '').split('\n').forEach((line) => {
        const index = line.lastIndexOf(':');
        if (index < 1) return;
        map[line.slice(0, index).trim().toLowerCase()] = line.slice(index + 1).trim();
      });
      return map;
    }

    swatchColor(value) {
      return this.swatches[String(value).trim().toLowerCase()] || '';
    }

    paintSwatches(root) {
      root.querySelectorAll('[data-swatch]').forEach((chip) => {
        const color = this.swatchColor(chip.dataset.swatch);
        if (color) chip.style.background = color;
      });
    }

    /* A new row: first value of every option, except size which the shopper must choose. */
    blankUnit() {
      const unit = this.optionNames.map((name, index) => {
        if (index === this.sizePosition - 1) return null;
        return this.variants.length ? this.variants[0].options[index] : null;
      });
      unit.style = this.handle;
      return unit;
    }

    cloneUnit(unit) {
      const copy = unit.slice();
      copy.style = unit.style;
      return copy;
    }

    variantsFor(style) {
      return style && this.pool && this.pool[style] ? this.pool[style].variants : this.variants;
    }

    optionValues(index) {
      const values = [];
      this.variants.forEach((variant) => {
        if (!values.includes(variant.options[index])) values.push(variant.options[index]);
      });
      return values;
    }

    renderRows(count) {
      while (this.units.length < count) {
        this.units.push(this.cloneUnit(this.units[0]));
      }
      this.units.length = count;
      const active = this.tier.input;
      /* Rows are rebuilt on every change, so keyboard focus is put back where it was. */
      const focused = document.activeElement && document.activeElement.closest ? document.activeElement.closest('.bx-row') : null;
      let refocus = null;
      if (focused && this.contains(focused)) {
        const rows = Array.from(focused.parentNode.querySelectorAll('.bx-row'));
        refocus = { row: rows.indexOf(focused), color: document.activeElement.hasAttribute('data-row-color'), style: document.activeElement.hasAttribute('data-row-style'), option: document.activeElement.dataset.rowOption };
      }
      this.tiers.forEach((input) => {
        const holder = input.closest('.mp-tier').querySelector('[data-tier-rows]');
        if (!holder) return;
        holder.textContent = '';
        if (input !== active) return;
        if (this.fit) {
          const head = document.createElement('div');
          head.className = 'bx-rows__head';
          const hint = document.createElement('span');
          const picks = this.mixOn ? 'style' : this.colorPosition > 0 ? 'color' : '';
          hint.textContent = picks
            ? (this.units.length > 1 ? 'Pick a ' + picks + ' and size for each' : 'Pick your ' + picks + ' and size')
            : (this.units.length > 1 ? 'Pick a size for each' : 'Pick your size');
          const link = document.createElement('button');
          link.type = 'button';
          link.className = 'bx-fit-link' + (this.fitSize ? ' is-done' : '');
          link.dataset.fitOpen = '';
          link.setAttribute('aria-haspopup', 'dialog');
          link.textContent = this.fitSize ? 'Your size: ' + this.fitSize : this.fitLabel || 'Find my size';
          head.appendChild(hint);
          head.appendChild(link);
          holder.appendChild(head);
        }
        this.units.forEach((unit, i) => holder.appendChild(this.buildRow(unit, i)));
        if (refocus) {
          const row = holder.querySelectorAll('.bx-row')[refocus.row];
          const target = row ? row.querySelector(refocus.style ? '[data-row-style]' : refocus.color ? '[data-row-color]' : '[data-row-option="' + refocus.option + '"]') : null;
          if (target) target.focus({ preventScroll: true });
        }
      });
    }

    buildRow(unit, i) {
      const row = document.createElement('div');
      row.className = 'bx-row';
      const number = document.createElement('span');
      number.className = 'bx-row__n';
      number.textContent = '#' + (i + 1);
      row.appendChild(number);

      const colorIndex = this.colorPosition - 1;
      if (this.mixOn) {
        const styles = Object.values(this.pool);
        const current = this.pool[unit.style] || this.pool[this.handle];
        if (current && current.image) {
          const thumb = document.createElement('img');
          thumb.className = 'bx-row__thumb';
          thumb.src = current.image;
          thumb.alt = '';
          thumb.width = 40;
          thumb.height = 40;
          row.appendChild(thumb);
        }
        const wrap = document.createElement('span');
        wrap.className = 'bx-row__color bx-row__style';
        const styleSelect = document.createElement('select');
        styleSelect.className = 'bx-row__select';
        styleSelect.dataset.rowStyle = '';
        styleSelect.setAttribute('aria-label', (this.dataset.styleLabel || 'Style') + ' for item ' + (i + 1));
        styles.forEach((item) => {
          const option = document.createElement('option');
          option.value = item.handle;
          option.textContent = item.title;
          option.selected = item.handle === unit.style;
          styleSelect.appendChild(option);
        });
        styleSelect.addEventListener('change', () => {
          unit.style = styleSelect.value;
          this.update();
        });
        wrap.appendChild(styleSelect);
        row.appendChild(wrap);
      } else if (colorIndex >= 0) {
        const image = this.colorImage(unit[colorIndex]);
        if (image) {
          const thumb = document.createElement('img');
          thumb.className = 'bx-row__thumb';
          thumb.src = image;
          thumb.alt = '';
          thumb.width = 40;
          thumb.height = 40;
          row.appendChild(thumb);
        }
        /* One dropdown per item keeps the row short, whatever the number of colors. */
        const wrap = document.createElement('span');
        wrap.className = 'bx-row__color';
        const swatch = document.createElement('span');
        swatch.className = 'bx-row__swatch';
        const fill = this.swatchColor(unit[colorIndex]);
        if (fill) swatch.style.background = fill;
        const colorSelect = document.createElement('select');
        colorSelect.className = 'bx-row__select';
        colorSelect.dataset.rowColor = '';
        colorSelect.setAttribute('aria-label', this.optionNames[colorIndex] + ' for item ' + (i + 1));
        this.optionValues(colorIndex).forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          option.selected = value === unit[colorIndex];
          colorSelect.appendChild(option);
        });
        colorSelect.addEventListener('change', () => {
          unit[colorIndex] = colorSelect.value;
          this.update();
          this.lastColor = null;
          this.showColor(colorSelect.value);
        });
        wrap.appendChild(swatch);
        wrap.appendChild(colorSelect);
        row.appendChild(wrap);
      }

      this.optionNames.forEach((name, optionIndex) => {
        if (optionIndex === colorIndex) return;
        const select = document.createElement('select');
        select.className = 'bx-row__select';
        select.dataset.rowOption = String(optionIndex);
        select.setAttribute('aria-label', name + ' for item ' + (i + 1));
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = name;
        placeholder.disabled = true;
        placeholder.selected = unit[optionIndex] === null;
        select.appendChild(placeholder);
        this.optionValues(optionIndex).forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          const probe = this.cloneUnit(unit);
          probe[optionIndex] = value;
          const variant = this.findVariant(probe, probe.style);
          const soldOut = !variant || !variant.available;
          option.textContent = value + (soldOut ? ' (sold out)' : '');
          option.disabled = soldOut;
          option.selected = value === unit[optionIndex];
          select.appendChild(option);
        });
        if (unit[optionIndex] === null && this.showMissing) select.classList.add('is-missing');
        select.addEventListener('change', () => {
          unit[optionIndex] = select.value;
          /* Choosing on the first item fills the items that have no choice yet. */
          if (i === 0) {
            this.units.forEach((other) => {
              if (other[optionIndex] === null) other[optionIndex] = select.value;
            });
          }
          this.update();
        });
        row.appendChild(select);
      });
      return row;
    }

    unitComplete(unit) {
      return unit.every((value) => value !== null && value !== '');
    }

    readMainOptions() {
      return this.optionNames.map((name, index) => {
        const checked = this.querySelector('[data-option="' + (index + 1) + '"] [data-option-input]:checked');
        if (checked) return checked.value;
        return this.variants.length ? this.variants[0].options[index] : null;
      });
    }

    findVariant(options, style) {
      return this.variantsFor(style).find((variant) => variant.options.every((value, index) => value === options[index]));
    }

    get tier() {
      const input = this.tiers.find((item) => item.checked) || this.tiers[0];
      if (!input) return { units: 1, payUnits: 1, title: '' };
      return { units: Number(input.dataset.units || 1), payUnits: Number(input.dataset.payUnits || 1), title: input.dataset.title || '', input };
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(this.dataset.locale || undefined, { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
      } catch (err) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    /* Greys out option values that are sold out with the rest of unit 1's selection. */
    markAvailability() {
      if (this.inline) return;
      const current = this.units[0];
      this.querySelectorAll('[data-option]').forEach((fieldset) => {
        const index = Number(fieldset.dataset.option) - 1;
        fieldset.querySelectorAll('[data-option-input]').forEach((input) => {
          const probe = current.slice();
          probe[index] = input.value;
          const variant = this.findVariant(probe);
          input.closest('label').classList.toggle('is-unavailable', !variant || !variant.available);
        });
        const label = fieldset.querySelector('[data-option-value]');
        if (label) label.textContent = current[index] || '';
        fieldset.querySelectorAll('[data-bundle]').forEach((input) => {
          const card = input.closest('.mp-tier');
          card.classList.toggle('is-selected', input.checked);
          const probe = current.slice();
          probe[index] = input.value;
          const variant = this.findVariant(probe);
          if (!variant) return;
          /* "3-Pack (Buy 2 Get 1)" holds 3 units; "1 Pair" holds 1. */
          const count = parseInt(input.value, 10) || 1;
          const priceEl = card.querySelector('[data-bundle-price]');
          const compareEl = card.querySelector('[data-bundle-compare]');
          const unitEl = card.querySelector('[data-bundle-unit]');
          const saveEl = card.querySelector('[data-bundle-save]');
          priceEl.textContent = this.money(variant.price);
          const hasCompare = variant.compare > variant.price;
          compareEl.hidden = !hasCompare;
          compareEl.textContent = this.money(variant.compare);
          saveEl.hidden = !hasCompare;
          if (hasCompare) saveEl.textContent = 'SAVE ' + Math.round(((variant.compare - variant.price) / variant.compare) * 100) + '%';
          unitEl.hidden = count < 2;
          unitEl.textContent = this.money(Math.round(variant.price / count)) + ' / ' + (this.dataset.unitLabel || 'item');
        });
      });
    }

    renderUnits(count) {
      if (this.inline) {
        this.renderRows(count);
        return;
      }
      while (this.units.length < count) {
        this.units.push(this.units[0].slice());
        this.touched.push(false);
      }
      this.units.length = count;
      this.touched.length = count;
      for (let i = 1; i < count; i += 1) {
        if (!this.touched[i]) this.units[i] = this.units[0].slice();
      }

      if (!this.unitsEl) return;
      const heading = this.querySelector('[data-unit-heading]');
      if (heading) heading.hidden = count < 2;
      this.unitsEl.hidden = count < 2;
      this.unitsEl.textContent = '';
      if (count < 2) return;

      const unitLabel = this.dataset.unitLabel || 'item';
      const payUnits = this.tier.payUnits;
      for (let i = 1; i < count; i += 1) {
        const row = document.createElement('div');
        row.className = 'bx-unit';
        const label = document.createElement('span');
        label.className = 'bx-unit__label';
        const chip = document.createElement('span');
        chip.className = 'bx-unit__chip';
        if (this.colorPosition > 0) {
          const colorName = this.units[i][this.colorPosition - 1];
          const image = this.colorImage(colorName);
          if (image) {
            const thumb = document.createElement('img');
            thumb.className = 'bx-unit__thumb';
            thumb.src = image;
            thumb.alt = '';
            thumb.width = 36;
            thumb.height = 36;
            label.appendChild(thumb);
          } else {
            const color = this.swatchColor(colorName);
            if (color) chip.style.background = color;
            label.appendChild(chip);
          }
        }
        const text = document.createElement('span');
        text.textContent = unitLabel.charAt(0).toUpperCase() + unitLabel.slice(1) + ' ' + (i + 1);
        label.appendChild(text);
        if (i >= payUnits) {
          const free = document.createElement('span');
          free.className = 'bx-unit__free';
          free.textContent = 'FREE';
          label.appendChild(free);
        }
        row.appendChild(label);

        this.optionNames.forEach((name, optionIndex) => {
          const select = document.createElement('select');
          select.setAttribute('aria-label', text.textContent + ' ' + name);
          const values = [];
          this.variants.forEach((variant) => {
            if (!values.includes(variant.options[optionIndex])) values.push(variant.options[optionIndex]);
          });
          values.forEach((value) => {
            const option = document.createElement('option');
            option.value = value;
            const probe = this.units[i].slice();
            probe[optionIndex] = value;
            const variant = this.findVariant(probe);
            option.textContent = value + (variant && variant.available ? '' : ' (sold out)');
            option.selected = value === this.units[i][optionIndex];
            select.appendChild(option);
          });
          select.addEventListener('change', () => {
            this.units[i][optionIndex] = select.value;
            this.touched[i] = true;
            this.update();
          });
          row.appendChild(select);
        });
        const variant = this.findVariant(this.units[i]);
        row.classList.toggle('is-soldout', !variant || !variant.available);
        this.unitsEl.appendChild(row);
      }
    }

    update(fromMain) {
      const tier = this.tier;
      this.tiers.forEach((input) => input.closest('.mp-tier').classList.toggle('is-selected', input === tier.input));
      this.markAvailability();
      this.renderUnits(tier.units);

      const chosen = this.units.map((options) => this.findVariant(options, options.style));
      const main = chosen.find(Boolean);
      const complete = this.units.every((unit) => this.unitComplete(unit));
      const soldOut = this.units.some((unit, i) => this.unitComplete(unit) && (!chosen[i] || !chosen[i].available));
      const allAvailable = !soldOut;
      if (main) this.variantInput.value = main.id;
      const fallback = this.variants.length ? this.variants[0] : { price: 0, compare: 0 };

      /* Paid units are the most expensive ones, matching how Shopify applies Buy X Get Y. */
      const prices = chosen.map((variant) => (variant || fallback).price).sort((a, b) => b - a);
      /* Amount-off bundles: the discount is set in the store currency, so it follows the exchange rate. */
      const rate = window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate) > 0 ? Number(window.Shopify.currency.rate) : 1;
      const offOf = (input) => Math.round(Number((input && input.dataset.off) || 0) * rate);
      const fixedTotal = offOf(tier.input);
      /* Percentage bundles: the same share comes off in every currency, so page and cart always agree. */
      const keepOf = (input) => 1 - Math.min(100, Math.max(0, Number((input && input.dataset.percent) || 0))) / 100;
      const total = Math.max(0, Math.round(prices.slice(0, tier.payUnits).reduce((sum, value) => sum + value, 0) * keepOf(tier.input)) - fixedTotal);

      this.tiers.forEach((input) => {
        const units = Number(input.dataset.units || 1);
        const payUnits = Number(input.dataset.payUnits || 1);
        const fixed = offOf(input);
        const baseVariant = main || fallback;
        const base = baseVariant.price;
        const compareBase = baseVariant.compare > baseVariant.price ? baseVariant.compare : base;
        const card = input.closest('.mp-tier');
        const price = input === tier.input ? total : Math.max(0, Math.round(base * payUnits * keepOf(input)) - fixed);
        const compare = compareBase * units;
        const priceEl = card.querySelector('[data-tier-price]');
        const compareEl = card.querySelector('[data-tier-compare]');
        const unitEl = card.querySelector('[data-tier-unit]');
        if (priceEl) priceEl.textContent = this.money(price);
        if (compareEl) {
          compareEl.hidden = compare <= price;
          compareEl.textContent = this.money(compare);
        }
        if (unitEl) {
          unitEl.hidden = units < 2;
          unitEl.textContent = this.money(Math.round(price / units)) + ' / ' + (this.dataset.unitLabel || 'item');
        }
      });

      if (this.colorPosition > 0) {
        const mainImage = this.colorImage(this.units[0][this.colorPosition - 1]);
        if (mainImage) this.querySelectorAll('[data-tier-thumb]').forEach((img) => { img.removeAttribute('srcset'); img.src = mainImage; });
      }

      const label = this.querySelector('[data-submit-label]');
      const priceEl = this.querySelector('[data-submit-price]');
      this.complete = complete;
      if (complete && this.showMissing) {
        this.showMissing = false;
        const error = this.querySelector('[data-error]');
        if (error) error.hidden = true;
      }
      if (label) label.textContent = allAvailable ? label.dataset.label : label.dataset.soldout;
      if (priceEl) priceEl.textContent = allAvailable ? '– ' + this.money(total) : '';
      this.submitButtons.forEach((button) => (button.disabled = !allAvailable));
      const note = this.querySelector('[data-discount-note]');
      if (note) note.hidden = tier.payUnits >= tier.units && fixedTotal === 0 && keepOf(tier.input) === 1;
      /* Gifts unlock with the number of items: bundle units, or the pack size ("3-Pack" = 3). */
      const packInput = this.querySelector('[data-bundle]:checked');
      const count = this.tiers.length ? tier.units : packInput ? parseInt(packInput.value, 10) || 1 : 1;
      this.querySelectorAll('[data-gift]').forEach((gift) => {
        const min = Number(gift.dataset.min || 1);
        const locked = count < min;
        gift.classList.toggle('is-locked', locked);
        const state = gift.querySelector('[data-gift-state]');
        if (state) state.textContent = locked ? String(state.dataset.locked || '').replace('[n]', min) : state.dataset.free;
      });
      const stickyPrice = this.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = (tier.title ? tier.title + ' · ' : '') + this.money(total);

      if (fromMain && main) {
        if (main.media) this.showMedia(main.media);
        else if (this.colorPosition > 0) this.showColor(main.options[this.colorPosition - 1]);
      }
    }

    initFit() {
      const dialog = this.querySelector('[data-fit]');
      if (!dialog) return;
      const disable = (reason) => {
        this.querySelectorAll('[data-fit-open]').forEach((button) => (button.hidden = true));
        if (window.console) console.warn('Blinx size finder is off: ' + reason);
      };
      let config = null;
      try {
        config = JSON.parse(this.querySelector('[data-fit-config]').textContent);
      } catch (err) {
        config = null;
      }
      if (!config) return disable('no settings');

      const fit = { mode: config.mode, tableUnit: config.unit === 'cm' ? 'cm' : 'in', unit: 'in', weightUnit: 'lb', chartUnit: 'in', sizes: config.sizes || [], result: null };
      if (fit.mode === 'body') {
        fit.body = { weights: BxFit.list(config.weights), tall: BxFit.list(config.tall), bust: BxFit.list(config.bust), sizes: fit.sizes };
        /* One step between each pair of sizes, or the answer could point at the wrong size. */
        if (fit.sizes.length < 2 || fit.body.weights.length !== fit.sizes.length - 1) return disable('weight steps do not match the sizes');
        if (fit.body.bust.length && fit.body.bust.length !== fit.sizes.length - 1) return disable('bust steps do not match the sizes');
      } else {
        fit.rows = BxFit.parseTable(config.table, fit.sizes);
        if (fit.rows.length < 2) return disable('size table has fewer than two usable rows');
        for (let i = 1; i < fit.rows.length; i += 1) {
          if (fit.rows[i].a[0] < fit.rows[i - 1].a[0]) return disable('size table is not in ascending order');
        }
        if (fit.rows.some((row) => row.b) && !fit.rows.every((row) => row.b)) fit.rows.forEach((row) => (row.b = null));
        const missing = fit.sizes.filter((size) => !fit.rows.some((row) => row.key === BxFit.norm(size)));
        if (missing.length && window.console) console.warn('Blinx size finder: no chart row for ' + missing.join(', '));
      }
      this.fit = fit;
      const firstLabel = this.querySelector('[data-fit-label]');
      this.fitLabel = (firstLabel && firstLabel.dataset.default) || dialog.querySelector('.bx-fit__title').textContent.trim();

      const find = dialog.querySelector('[data-fit-pane="find"]');
      const chart = dialog.querySelector('[data-fit-pane="chart"]');
      const resultEl = dialog.querySelector('[data-fit-result]');
      const applyButton = dialog.querySelector('[data-fit-apply]');
      const inputA = dialog.querySelector('[data-fit-measure="a"]');
      const inputB = dialog.querySelector('[data-fit-measure="b"]');
      const inputBust = dialog.querySelector('[data-fit-measure="bust"]');
      const heightEl = dialog.querySelector('[data-fit-height]');
      const weightEl = dialog.querySelector('[data-fit-weight]');
      const labelA = String(config.labelA || 'Measurement');
      const labelB = String(config.labelB || '');
      const el = (tag, className, text) => {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text != null) node.textContent = text;
        return node;
      };
      const trim = (value) => String(Math.round(value * 10) / 10);
      const both = (length) => trim(length.in) + ' in (' + Math.round(length.cm) + ' cm)';
      const storeKey = 'bx-fit-v1';
      const load = () => {
        try {
          return JSON.parse(window.localStorage.getItem(storeKey)) || {};
        } catch (err) {
          return {};
        }
      };
      const save = (patch) => {
        try {
          window.localStorage.setItem(storeKey, JSON.stringify(Object.assign(load(), patch)));
        } catch (err) {
          /* Storage can be blocked. The finder works without it. */
        }
      };

      if (heightEl) {
        for (let inches = 56; inches <= 78; inches += 1) {
          const option = el('option', '', Math.floor(inches / 12) + "' " + (inches % 12) + '"  ·  ' + Math.round(inches * BxFit.IN) + ' cm');
          option.value = String(inches);
          heightEl.appendChild(option);
        }
      }

      const setUnit = (pane, unit) => {
        pane.querySelectorAll('[data-fit-unit]').forEach((button) => {
          const active = button.dataset.fitUnit === unit;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (pane === find) {
          fit.unit = unit;
          find.querySelectorAll('[data-fit-suffix]').forEach((suffix) => (suffix.textContent = unit));
          const sample = { a: fit.rows ? fit.rows[Math.floor(fit.rows.length / 2)].a[0] : 0 };
          const hint = (value) => 'e.g. ' + Math.round(fit.tableUnit === unit ? value : unit === 'cm' ? value * BxFit.IN : value / BxFit.IN);
          if (inputA && fit.rows) inputA.placeholder = hint(sample.a);
          if (inputB && fit.rows && fit.rows[0].b) inputB.placeholder = hint(fit.rows[Math.floor(fit.rows.length / 2)].b[0]);
          if (inputBust) inputBust.placeholder = unit === 'cm' ? 'e.g. 97' : 'e.g. 38';
        } else {
          fit.chartUnit = unit;
        }
      };
      const setWeightUnit = (unit) => {
        fit.weightUnit = unit;
        dialog.querySelectorAll('[data-fit-wunit]').forEach((button) => {
          const active = button.dataset.fitWunit === unit;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (weightEl) weightEl.placeholder = unit === 'kg' ? 'e.g. 75' : 'e.g. 165';
      };

      const showError = (key, message) => {
        const node = dialog.querySelector('[data-fit-error="' + key + '"]');
        if (!node) return;
        node.hidden = !message;
        node.textContent = message || '';
        const input = key === 'weight' ? weightEl : dialog.querySelector('[data-fit-measure="' + key + '"]');
        if (input) input.classList.toggle('is-invalid', Boolean(message));
      };

      /* Reads one length field. Returns null when empty, false when unreadable. */
      const readField = (input, key, name) => {
        if (!input || !input.value.trim()) {
          showError(key, '');
          return null;
        }
        const length = BxFit.readLength(input.value, fit.unit);
        if (length.error) {
          showError(key, 'That ' + name.toLowerCase() + ' does not look right. Enter a number in inches (18 to 80) or centimeters (46 to 203).');
          return false;
        }
        showError(key, '');
        return length;
      };

      const renderChart = () => {
        const table = dialog.querySelector('[data-fit-table]');
        const caption = dialog.querySelector('[data-fit-chart-caption]');
        if (!table) return;
        const unit = fit.chartUnit;
        if (caption) caption.textContent = unit === 'cm' ? 'Body measurements in centimeters' : 'Body measurements in inches';
        const show = (value, from) => {
          if (value === Infinity) return '';
          if (from === unit) return trim(value);
          return unit === 'cm' ? String(Math.round(value * BxFit.IN)) : trim(Math.round((value / BxFit.IN) * 2) / 2);
        };
        const span = (range, from) => (range[1] === Infinity ? show(range[0], from) + ' and up' : range[0] === -Infinity ? 'Under ' + show(range[1], from) : show(range[0], from) + ' – ' + show(range[1], from));
        table.textContent = '';
        const head = el('tr');
        const body = [];
        if (fit.mode === 'body') {
          ['Size', 'Full bust (' + unit + ')'].forEach((text) => head.appendChild(el('th', '', text)));
          fit.sizes.forEach((size, i) => {
            const steps = fit.body.bust;
            if (!steps.length) return;
            const range = [i === 0 ? -Infinity : steps[i - 1], i === steps.length ? Infinity : steps[i]];
            body.push({ size, cells: [size, span(range, 'in')] });
          });
        } else {
          const hasUs = fit.rows.some((row) => row.us);
          const hasB = Boolean(fit.rows[0].b);
          ['Size'].concat(hasUs ? ['US size'] : [], [labelA + ' (' + unit + ')'], hasB ? [labelB + ' (' + unit + ')'] : []).forEach((text) => head.appendChild(el('th', '', text)));
          fit.rows.forEach((row) => {
            body.push({ size: row.label, cells: [row.label].concat(hasUs ? [row.us] : [], [span(row.a, fit.tableUnit)], hasB ? [span(row.b, fit.tableUnit)] : []) });
          });
        }
        table.appendChild(head);
        body.forEach((row) => {
          const tr = el('tr', fit.result && fit.result.size === row.size ? 'is-match' : '');
          row.cells.forEach((text, i) => tr.appendChild(el(i === 0 ? 'th' : 'td', '', text)));
          if (i0(row)) tr.setAttribute('aria-current', 'true');
          table.appendChild(tr);
        });
      };
      const i0 = (row) => Boolean(fit.result && fit.result.size === row.size);

      const sizeAvailable = (size) => this.variants.some((variant) => variant.available && variant.options[this.sizePosition - 1] === size);

      const render = (result) => {
        fit.result = result;
        resultEl.textContent = '';
        resultEl.hidden = !result;
        resultEl.classList.toggle('is-none', Boolean(result && !result.size));
        if (!result) {
          applyButton.disabled = true;
          applyButton.textContent = fit.mode === 'body' ? 'Enter your height and weight' : 'Enter your ' + labelA.toLowerCase();
          renderChart();
          return;
        }
        if (result.size) {
          const top = el('div', 'bx-fit__answer');
          top.appendChild(el('span', 'bx-fit__lead', 'Your size'));
          top.appendChild(el('strong', 'bx-fit__size', result.size));
          resultEl.appendChild(top);
        } else {
          resultEl.appendChild(el('p', 'bx-fit__none', result.title));
        }
        if (result.echo) resultEl.appendChild(el('p', 'bx-fit__echo', result.echo));
        if (result.meter) {
          const meter = el('div', 'bx-fit__meter');
          const bar = el('div', 'bx-fit__bar');
          const dot = el('span', 'bx-fit__dot');
          dot.style.left = Math.min(96, Math.max(4, result.meter.position * 100)) + '%';
          bar.appendChild(dot);
          meter.appendChild(bar);
          const ends = el('div', 'bx-fit__ends');
          ends.appendChild(el('span', '', result.meter.min));
          ends.appendChild(el('span', '', result.size + ' range'));
          ends.appendChild(el('span', '', result.meter.max));
          meter.appendChild(ends);
          resultEl.appendChild(meter);
        }
        if (result.notes.length) {
          const list = el('ul', 'bx-fit__notes');
          result.notes.forEach((note) => list.appendChild(el('li', '', note)));
          resultEl.appendChild(list);
        }
        if (result.size) {
          const count = this.inline ? this.tier.units : 1;
          applyButton.disabled = false;
          applyButton.textContent = count > 1 ? 'Use ' + result.size + ' for all ' + count + ' items' : 'Select size ' + result.size;
        } else {
          applyButton.disabled = true;
          applyButton.textContent = 'No matching size';
        }
        renderChart();
      };

      const computeChart = () => {
        const a = readField(inputA, 'a', labelA);
        const b = inputB ? readField(inputB, 'b', labelB) : null;
        if (a === false || b === false || !a) return render(null);
        const switched = a.switched || (b && b.switched);
        if (switched) setUnit(find, a.switched ? a.unit : b.unit);
        const rows = fit.rows;
        const outcome = BxFit.fromChart(rows, BxFit.native(a, fit.tableUnit), b ? BxFit.native(b, fit.tableUnit) : null);
        const notes = [];
        const lowerA = labelA.toLowerCase();
        const lowerB = labelB.toLowerCase();
        const echo = labelA + ' ' + both(a) + (b ? '  ·  ' + labelB + ' ' + both(b) : '');
        if (switched) notes.push('We read your number as ' + (a.switched ? a.unit : b.unit) + '. Check the measurement above is right.');
        const unitText = (value) => (fit.tableUnit === fit.unit ? trim(value) : fit.unit === 'cm' ? String(Math.round(value * BxFit.IN)) : trim(Math.round((value / BxFit.IN) * 2) / 2)) + ' ' + fit.unit;
        if (outcome.status === 'above') {
          const last = rows[rows.length - 1];
          const key = outcome.driver;
          return render({ size: null, title: 'We do not have your size in this style yet.', echo, notes: notes.concat(['Our largest size, ' + last.label + ', fits a ' + (key === 'a' ? lowerA : lowerB) + ' up to ' + unitText(last[key][1]) + '. We would rather tell you than send something that will not fit. Write to us and we will help.']) });
        }
        const row = rows[outcome.index];
        const driverName = outcome.driver === 'a' ? lowerA : lowerB;
        if (outcome.status === 'below') notes.push('You are below our smallest size. ' + row.label + ' is the closest fit and may feel a little loose.');
        if (outcome.status === 'between') notes.push('Your ' + driverName + ' falls between ' + rows[outcome.lower].label + ' and ' + row.label + '. We chose ' + row.label + ' so it is not too tight.');
        if (outcome.status === 'edge') notes.push('Your ' + driverName + ' is right on the line between ' + rows[outcome.lower].label + ' and ' + row.label + '. We chose ' + row.label + ' so it is not too tight.');
        if (outcome.raised) notes.push('Your ' + lowerB + ' need more room than your ' + lowerA + ', so we went up to ' + row.label + '.');
        const next = rows[outcome.index + 1];
        if (outcome.status === 'in' && outcome.position >= 0.8 && next) notes.push('You are at the top of ' + row.label + '. Prefer a looser fit? ' + next.label + ' will work too.');
        if (inputB && !b && rows[0].b) notes.push('Add your ' + lowerB + ' for a more precise answer.');
        if (!sizeAvailable(row.label)) notes.push(row.label + ' is sold out right now.');
        const range = row[outcome.driver];
        const meter = (outcome.status === 'in' || outcome.status === 'edge') && range[1] !== Infinity ? { position: outcome.position || 0, min: unitText(range[0]), max: unitText(range[1]) } : null;
        const saved = {};
        saved[lowerA] = a.in;
        if (b) saved[lowerB] = b.in;
        saved.unit = fit.unit;
        save(saved);
        return render({ size: row.label, echo, meter, notes });
      };

      const computeBody = () => {
        const height = heightEl && heightEl.value ? Number(heightEl.value) : null;
        let weight = null;
        if (weightEl && weightEl.value.trim()) {
          weight = BxFit.readWeight(weightEl.value, fit.weightUnit);
          if (weight.error) {
            showError('weight', 'That weight does not look right. Enter pounds (70 to 500) or kilograms (32 to 227).');
            weight = false;
          } else {
            showError('weight', '');
            if (weight.switched) setWeightUnit(weight.unit);
          }
        } else {
          showError('weight', '');
        }
        const bust = readField(inputBust, 'bust', 'bust measurement');
        if (bust && bust.switched) setUnit(find, bust.unit);
        if (!height || !weight || bust === false) return render(null);
        const outcome = BxFit.fromBody(fit.body, height, weight.lb, bust ? bust.in : null);
        const size = fit.sizes[outcome.index];
        const notes = [];
        const echo = Math.floor(height / 12) + "' " + (height % 12) + '"  ·  ' + Math.round(weight.lb) + ' lb (' + Math.round(weight.kg) + ' kg)' + (bust ? '  ·  Bust ' + both(bust) : '');
        if ((bust && bust.switched) || weight.switched) notes.push('We changed the unit to match your number. Check the values above are right.');
        if (outcome.raised) notes.push('Sized up for your bust. It needs more room than your height and weight alone suggest.');
        else if (bust) notes.push('Based on your height, weight and bust.');
        else notes.push('Based on your height and weight. Add your full bust for a more precise answer.');
        if (outcome.top) notes.push(size + ' is our largest size. If you are well above it, write to us before you order.');
        if (!sizeAvailable(size)) notes.push(size + ' is sold out right now.');
        save({ height, lb: weight.lb, weightUnit: fit.weightUnit, bust: bust ? bust.in : undefined, unit: fit.unit });
        return render({ size, echo, meter: null, notes });
      };

      const compute = () => (fit.mode === 'body' ? computeBody() : computeChart());

      const prefill = () => {
        const saved = load();
        const put = (input, inches) => {
          if (!input || input.value || !(inches > 0)) return;
          input.value = fit.unit === 'cm' ? String(Math.round(inches * BxFit.IN)) : trim(inches);
        };
        if (saved.unit === 'cm' || saved.unit === 'in') setUnit(find, saved.unit);
        put(inputA, saved[labelA.toLowerCase()]);
        put(inputB, saved[labelB.toLowerCase()]);
        put(inputBust, saved.bust);
        if (heightEl && !heightEl.value && saved.height) heightEl.value = String(saved.height);
        if (weightEl && !weightEl.value && saved.lb > 0) {
          if (saved.weightUnit === 'kg') setWeightUnit('kg');
          weightEl.value = String(Math.round(fit.weightUnit === 'kg' ? saved.lb * BxFit.LB : saved.lb));
        }
      };

      const showTab = (name) => {
        dialog.querySelectorAll('[data-fit-tab]').forEach((tab) => {
          const active = tab.dataset.fitTab === name;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        find.hidden = name !== 'find';
        chart.hidden = name !== 'chart';
      };
      const tabs = Array.from(dialog.querySelectorAll('[data-fit-tab]'));
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => showTab(tab.dataset.fitTab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          const other = tabs[(index + 1) % tabs.length];
          showTab(other.dataset.fitTab);
          other.focus();
        });
      });

      const zone = (name) => dialog.querySelectorAll('.bx-fit__band').forEach((band) => band.classList.toggle('is-active', band.dataset.zone === name));
      dialog.querySelectorAll('[data-fit-zone]').forEach((field) => field.addEventListener('focusin', () => zone(field.dataset.fitZone)));
      const firstZone = dialog.querySelector('[data-fit-zone]');
      if (firstZone) zone(firstZone.dataset.fitZone);

      const open = () => {
        prefill();
        compute();
        showTab('find');
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        document.documentElement.classList.add('bx-fit-open');
        const first = heightEl || inputA;
        if (first && !first.value) first.focus({ preventScroll: true });
      };
      const close = () => {
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
      };
      dialog.addEventListener('close', () => document.documentElement.classList.remove('bx-fit-open'));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });
      dialog.querySelectorAll('[data-fit-close]').forEach((button) => button.addEventListener('click', close));
      /* Openers are re-created with the bundle rows, so the click is caught on the buy box. */
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-fit-open]')) open();
      });

      [inputA, inputB, inputBust, weightEl].forEach((input) => {
        if (input) input.addEventListener('input', compute);
      });
      if (heightEl) heightEl.addEventListener('change', compute);
      /* Switching the unit converts what is already typed, so the measurement itself never changes. */
      find.querySelectorAll('[data-fit-unit]').forEach((button) => button.addEventListener('click', () => {
        const next = button.dataset.fitUnit;
        if (next !== fit.unit) {
          [inputA, inputB, inputBust].forEach((input) => {
            if (!input || !input.value.trim()) return;
            const length = BxFit.readLength(input.value, fit.unit);
            if (length.error || length.switched) return;
            input.value = next === 'cm' ? String(Math.round(length.cm)) : trim(length.in);
          });
        }
        setUnit(find, next);
        compute();
      }));
      chart.querySelectorAll('[data-fit-unit]').forEach((button) => button.addEventListener('click', () => {
        setUnit(chart, button.dataset.fitUnit);
        renderChart();
      }));
      dialog.querySelectorAll('[data-fit-wunit]').forEach((button) => button.addEventListener('click', () => {
        const next = button.dataset.fitWunit;
        if (next !== fit.weightUnit && weightEl && weightEl.value.trim()) {
          const weight = BxFit.readWeight(weightEl.value, fit.weightUnit);
          if (!weight.error && !weight.switched) weightEl.value = String(Math.round(next === 'kg' ? weight.kg : weight.lb));
        }
        setWeightUnit(next);
        compute();
      }));

      applyButton.addEventListener('click', () => {
        if (!fit.result || !fit.result.size) return;
        const size = fit.result.size;
        const index = this.sizePosition - 1;
        if (this.inline) {
          this.units.forEach((unit) => (unit[index] = size));
        } else {
          const radio = Array.from(this.querySelectorAll('[data-option="' + this.sizePosition + '"] [data-option-input]')).find((item) => item.value === size);
          if (!radio) return;
          this.querySelectorAll('.bx-pill').forEach((pill) => pill.classList.remove('is-recommended'));
          radio.checked = true;
          radio.closest('label').classList.add('is-recommended');
          this.units[0] = this.readMainOptions();
        }
        this.fitSize = size;
        this.update();
        this.querySelectorAll('[data-fit-label]').forEach((label) => {
          label.textContent = 'Your size: ' + size;
          label.closest('.bx-fit-link').classList.add('is-done');
        });
        close();
      });

      setUnit(find, 'in');
      setUnit(chart, 'in');
      render(null);
    }

    /* Re-renders the theme cart drawer with the fresh cart and opens it. Returns false when the page has no drawer. */
    async openCartDrawer() {
      try {
        const wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (!wrapper || !document.getElementById('cart-drawer')) return false;
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(root + '?sections=cart-drawer-section');
        if (!response.ok) return false;
        const html = (await response.json())['cart-drawer-section'];
        if (!html) return false;
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-cart-drawer-section');
        if (!fresh || !fresh.querySelector('#cart-drawer')) return false;
        wrapper.innerHTML = fresh.innerHTML;
        await customElements.whenDefined('theme-drawer');
        const drawer = document.getElementById('cart-drawer');
        if (!drawer || typeof drawer.open !== 'function') return false;
        drawer.open();
        document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach((el) => {
          const badge = fresh.querySelector('.theme-drawer__badge');
          if (badge) el.textContent = badge.textContent.trim();
        });
        return true;
      } catch (err) {
        return false;
      }
    }

    async onSubmit(event) {
      if (!window.fetch) return;
      event.preventDefault();
      const tier = this.tier;
      const error = this.querySelector('[data-error]');
      if (error) error.hidden = true;
      if (this.inline && !this.complete) {
        this.showMissing = true;
        this.update();
        if (error) {
          const label = this.querySelector('[data-submit-label]');
          error.textContent = (label && label.dataset.choose) || 'Choose a size for each item.';
          error.hidden = false;
        }
        const missing = this.querySelector('.bx-row__select.is-missing');
        if (missing) missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      const chosen = this.units.slice(0, tier.units).map((options) => this.findVariant(options, options.style));
      if (chosen.some((variant) => !variant || !variant.available)) {
        if (error) {
          error.textContent = 'One of your selections is sold out. Please pick another ' + (this.mixOn ? 'style' : 'color') + ' or size.';
          error.hidden = false;
        }
        return;
      }
      /* Same variant picked several times becomes one line with a quantity. */
      const quantities = new Map();
      chosen.forEach((variant) => quantities.set(variant.id, (quantities.get(variant.id) || 0) + 1));
      const items = Array.from(quantities, ([id, quantity]) => {
        const item = { id, quantity };
        if (tier.units > 1 && tier.title) item.properties = { _bundle: tier.title };
        return item;
      });

      this.querySelectorAll('[data-gift]:not(.is-locked)[data-variant-id]').forEach((gift) => {
        items.push({ id: Number(gift.dataset.variantId), quantity: 1, properties: { _gift: 'true' } });
      });
      this.submitButtons.forEach((button) => (button.disabled = true));
      const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      try {
        if (this.dataset.replaceCart === 'true') {
          await fetch('/cart/clear.js', { method: 'POST', headers });
        }
        const response = await fetch('/cart/add.js', { method: 'POST', headers, body: JSON.stringify({ items }) });
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Could not add to cart');
        }
        const after = this.dataset.afterAdd;
        if (after === 'drawer' && (await this.openCartDrawer())) {
          this.submitButtons.forEach((button) => (button.disabled = false));
          return;
        }
        window.location.href = after === 'checkout' ? '/checkout' : this.dataset.cartUrl || '/cart';
      } catch (err) {
        this.submitButtons.forEach((button) => (button.disabled = false));
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        }
      }
    }

    /* Small image of a color, taken from the gallery image whose alt text starts with the color name. */
    colorImage(color) {
      if (!this.colorImages) {
        this.colorImages = {};
        this.querySelectorAll('[data-gallery] [data-alt]').forEach((slide) => {
          const img = slide.querySelector('img');
          if (img) this.colorImages[slide.dataset.alt] = (img.currentSrc || img.src || '').replace(/([?&])width=\d+/, '$1width=120');
        });
      }
      const prefix = String(color || '').toLowerCase() + ' ';
      const key = Object.keys(this.colorImages).find((alt) => alt.startsWith(prefix));
      return key ? this.colorImages[key] : '';
    }

    /* Variants without their own image: jump to the first gallery image whose alt text starts with the color name. */
    showColor(color) {
      const gallery = this.querySelector('[data-gallery]');
      if (!gallery || !color || color === this.lastColor) return;
      this.lastColor = color;
      const prefix = String(color).toLowerCase() + ' ';
      const slide = Array.from(gallery.children).find((item) => (item.dataset.alt || '').startsWith(prefix));
      if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.children[0].offsetLeft, behavior: 'smooth' });
    }

    showMedia(mediaId) {
      const gallery = this.querySelector('[data-gallery]');
      if (!gallery) return;
      const slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.children[0].offsetLeft, behavior: 'smooth' });
    }

    /* Full-screen viewer: tap an image to open it, tap again to zoom where you tapped, drag to pan. */
    initZoom() {
      const dialog = this.querySelector('[data-zoom-dialog]');
      const openers = Array.from(this.querySelectorAll('[data-zoom-open]'));
      if (!dialog || !openers.length) return;
      const stage = dialog.querySelector('[data-zoom-stage]');
      const image = dialog.querySelector('[data-zoom-img]');
      const count = dialog.querySelector('[data-zoom-count]');
      const hint = dialog.querySelector('[data-zoom-hint]');
      const sources = openers.map((button) => {
        const thumb = button.querySelector('img');
        return { src: button.dataset.zoomSrc, thumb, alt: (thumb && thumb.alt) || '' };
      });
      let index = 0;
      let returnFocus = null;
      const unzoom = () => {
        dialog.classList.remove('is-zoomed');
        image.style.width = '';
        stage.scrollTo(0, 0);
        hint.textContent = 'Tap the image to zoom in';
      };
      const show = (next) => {
        index = (next + sources.length) % sources.length;
        unzoom();
        const item = sources[index];
        const current = index;
        /* Show the gallery image straight away, then swap in the sharp one when it has loaded. */
        const quick = item.thumb && item.thumb.complete && item.thumb.currentSrc;
        image.src = quick || item.src;
        image.alt = item.alt;
        if (quick && quick !== item.src) {
          const sharp = new Image();
          sharp.onload = () => {
            if (index === current) image.src = item.src;
          };
          sharp.src = item.src;
        }
        count.textContent = index + 1 + ' / ' + sources.length;
      };
      const open = (start, opener) => {
        returnFocus = opener;
        show(start);
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        document.documentElement.classList.add('bx-zoom-open');
      };
      const close = () => {
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
      };
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('bx-zoom-open');
        unzoom();
        if (returnFocus) returnFocus.focus({ preventScroll: true });
      });
      openers.forEach((button, i) => button.addEventListener('click', () => open(i, button)));
      dialog.querySelector('[data-zoom-close]').addEventListener('click', close);
      dialog.querySelectorAll('[data-zoom-step]').forEach((button) => button.addEventListener('click', () => show(index + Number(button.dataset.zoomStep))));
      image.addEventListener('click', (event) => {
        if (dialog.classList.contains('is-zoomed')) {
          unzoom();
          return;
        }
        const box = image.getBoundingClientRect();
        const x = (event.clientX - box.left) / box.width;
        const y = (event.clientY - box.top) / box.height;
        /* Zoom so the image is about 2.6 times as wide as the screen: small labels become readable. */
        const natural = image.naturalWidth || box.width * 2;
        const width = Math.max(box.width * 2, Math.min(stage.clientWidth * 2.6, natural * 2));
        dialog.classList.add('is-zoomed');
        image.style.width = Math.round(width) + 'px';
        const height = width * (image.naturalHeight / image.naturalWidth || 1);
        stage.scrollLeft = Math.max(0, x * width - stage.clientWidth / 2);
        stage.scrollTop = Math.max(0, y * height - stage.clientHeight / 2);
        hint.textContent = 'Drag to move, tap to zoom out';
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') show(index + 1);
        if (event.key === 'ArrowLeft') show(index - 1);
      });
      /* Swipe left or right when not zoomed to change image. */
      let startX = null;
      stage.addEventListener('touchstart', (event) => {
        startX = event.touches.length === 1 && !dialog.classList.contains('is-zoomed') ? event.touches[0].clientX : null;
      }, { passive: true });
      stage.addEventListener('touchend', (event) => {
        if (startX === null || !event.changedTouches.length) return;
        const delta = event.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(delta) > 50 && sources.length > 1) show(index + (delta < 0 ? 1 : -1));
      }, { passive: true });
    }

    initGallery() {
      const gallery = this.querySelector('[data-gallery]');
      const thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      if (!gallery || !thumbs.length) return;
      const slides = Array.from(gallery.children);
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const slide = slides[Number(thumb.dataset.thumb)];
          if (slide) gallery.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        });
      });
      let frame;
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const position = gallery.scrollLeft + slides[0].offsetLeft;
          let index = 0;
          slides.forEach((slide, i) => {
            if (Math.abs(slide.offsetLeft - position) < Math.abs(slides[index].offsetLeft - position)) index = i;
          });
          thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
        });
      }, { passive: true });
    }

    initSticky() {
      const sticky = this.querySelector('[data-sticky]');
      const submit = this.querySelector('[data-submit]');
      if (!sticky || !submit || !('IntersectionObserver' in window)) return;
      /* Hide the bar while any part of the offer (tiers, item rows, button) is on screen,
         so it never covers the color and size pickers. */
      const watched = [this.querySelector('.mp-offer__tiers'), this.querySelector('[data-options]'), submit].filter(Boolean);
      const visible = new Set();
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => (entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target)));
        sticky.hidden = visible.size > 0;
      });
      watched.forEach((el) => io.observe(el));
      /* The sticky button brings the shopper back to the offer instead of adding blindly. */
      const go = sticky.querySelector('[data-sticky-go]');
      if (go) {
        go.addEventListener('click', () => {
          const target = this.querySelector('.mp-offer__tiers') || this.querySelector('[data-options]') || this.form;
          const top = target.getBoundingClientRect().top + window.scrollY - 90;
          const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
        });
      }
    }

    initShipDate() {
      const el = this.querySelector('[data-ships]');
      if (!el || !el.dataset.template) return;
      const date = new Date();
      let days = Number(this.dataset.shipDays || 1);
      while (days > 0) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) days -= 1;
      }
      while (date.getDay() === 0 || date.getDay() === 6) date.setDate(date.getDate() + 1);
      const label = date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      el.textContent = el.dataset.template.replace('[date]', label);
    }

    initCountdown() {
      const el = this.querySelector('[data-countdown]');
      if (!el) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const now = new Date();
        const end = new Date(now);
        end.setHours(24, 0, 0, 0);
        const left = Math.max(0, Math.floor((end - now) / 1000));
        el.textContent = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  if (!customElements.get('bx-buy-box')) customElements.define('bx-buy-box', BxBuyBox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-lp-bar"] && !Shopify.designMode) return;
  try {
    
  class MpLpBar extends HTMLElement {
    connectedCallback() {
      const timer = this.querySelector('[data-countdown]');
      if (timer) {
        const pad = (n) => String(n).padStart(2, '0');
        const tick = () => {
          const now = new Date();
          const end = new Date(now);
          end.setHours(24, 0, 0, 0);
          const left = Math.max(0, Math.floor((end - now) / 1000));
          timer.textContent = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
        };
        tick();
        setInterval(tick, 1000);
      }
      const sticky = this.querySelector('[data-sticky]');
      if (sticky) {
        const toggle = () => (sticky.hidden = window.scrollY < 500);
        window.addEventListener('scroll', toggle, { passive: true });
        toggle();
      }
    }
  }
  if (!customElements.get('mp-lp-bar')) customElements.define('mp-lp-bar', MpLpBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-product"] && !Shopify.designMode) return;
  try {
    
  class MpBuyBox extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-form]');
      if (!this.form) return;
      this.variantInput = this.querySelector('[data-variant-input]');
      this.planInput = this.querySelector('[data-plan-input]');
      this.subInput = this.querySelector('[data-sub-input]');
      this.subToggle = this.querySelector('[data-sub-toggle]');
      this.tiers = Array.from(this.querySelectorAll('[data-tier]'));
      this.submitButtons = Array.from(this.querySelectorAll('[data-submit], [data-sticky-submit]'));

      this.tiers.forEach((input) => input.addEventListener('change', () => this.update()));
      if (this.subInput) this.subInput.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      const once = this.querySelector('[data-buy-once]');
      if (once) {
        once.addEventListener('click', () => {
          this.buyOnce = true;
          this.form.requestSubmit();
        });
      }

      this.update();
      this.initGallery();
      this.initSticky();
      this.initShipDate();
      this.initCountdown();
    }

    get selected() {
      return this.tiers.find((input) => input.checked) || this.tiers[0];
    }

    update() {
      const input = this.selected;
      if (!input) return;
      const hasPlan = Boolean(input.dataset.plan);
      const subscribed = Boolean(this.subInput && this.subInput.checked && hasPlan);

      this.tiers.forEach((tier) => {
        const card = tier.closest('.mp-tier');
        card.classList.toggle('is-selected', tier === input);
        const showSub = Boolean(this.subInput && this.subInput.checked && tier.dataset.plan);
        card.querySelectorAll('[data-sub]').forEach((el) => (el.hidden = !showSub));
        card.querySelectorAll('[data-once]').forEach((el) => {
          const twin = el.parentElement.querySelector(':scope > [data-sub]');
          el.hidden = showSub && Boolean(twin);
        });
      });

      this.variantInput.value = input.value;
      if (this.planInput) {
        this.planInput.disabled = !subscribed;
        this.planInput.value = subscribed ? input.dataset.plan : '';
      }
      const subInfo = this.querySelector('[data-sub-info]');
      if (subInfo) {
        subInfo.hidden = !hasPlan;
        const refill = subInfo.querySelector('[data-sub-refill]');
        if (refill && input.dataset.subNote) refill.textContent = input.dataset.subNote;
        const oncePrice = subInfo.querySelector('[data-once-price]');
        if (oncePrice) oncePrice.textContent = input.dataset.price;
      }
      if (this.subToggle) {
        this.subToggle.hidden = !hasPlan;
        const note = this.subToggle.querySelector('[data-sub-note]');
        if (note && input.dataset.subNote && !note.dataset.fixed) {
          if (!note.dataset.base) note.dataset.base = note.textContent.trim();
          note.textContent = input.dataset.subNote + (note.dataset.base ? ' · ' + note.dataset.base : '');
        }
      }

      const price = subscribed ? input.dataset.subPrice : input.dataset.price;
      const priceEl = this.querySelector('[data-submit-price]');
      if (priceEl) priceEl.textContent = '– ' + price;
      const stickyTitle = this.querySelector('[data-sticky-title]');
      const stickyPrice = this.querySelector('[data-sticky-price]');
      if (stickyTitle) stickyTitle.textContent = input.dataset.title;
      if (stickyPrice) stickyPrice.textContent = price + (subscribed ? ' · subscription' : '');
    }

    /* Re-renders the theme cart drawer with the fresh cart and opens it. Returns false when the page has no drawer. */
    async openCartDrawer() {
      try {
        const wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (!wrapper || !document.getElementById('cart-drawer')) return false;
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(root + '?sections=cart-drawer-section');
        if (!response.ok) return false;
        const html = (await response.json())['cart-drawer-section'];
        if (!html) return false;
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-cart-drawer-section');
        if (!fresh || !fresh.querySelector('#cart-drawer')) return false;
        wrapper.innerHTML = fresh.innerHTML;
        await customElements.whenDefined('theme-drawer');
        const drawer = document.getElementById('cart-drawer');
        if (!drawer || typeof drawer.open !== 'function') return false;
        drawer.open();
        document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach((el) => {
          const badge = fresh.querySelector('.theme-drawer__badge');
          if (badge) el.textContent = badge.textContent.trim();
        });
        return true;
      } catch (err) {
        return false;
      }
    }

    async onSubmit(event) {
      if (!window.fetch) return;
      event.preventDefault();
      const input = this.selected;
      const subscribed = Boolean(this.subInput && this.subInput.checked && input.dataset.plan && !this.buyOnce);
      this.buyOnce = false;
      const main = { id: Number(input.value), quantity: 1 };
      if (subscribed) main.selling_plan = Number(input.dataset.plan);
      const items = [main];
      (input.dataset.gifts || '').split(',').filter(Boolean).forEach((id) => {
        items.push({ id: Number(id), quantity: 1, properties: { _gift: 'true', _parent_variant: String(input.value) } });
      });

      const error = this.querySelector('[data-error]');
      if (error) error.hidden = true;
      this.submitButtons.forEach((button) => (button.disabled = true));
      const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

      try {
        if (this.dataset.replaceCart === 'true') {
          await fetch('/cart/clear.js', { method: 'POST', headers });
        }
        const response = await fetch('/cart/add.js', { method: 'POST', headers, body: JSON.stringify({ items }) });
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Could not add to cart');
        }
        const after = this.dataset.afterAdd;
        if (after === 'drawer' && (await this.openCartDrawer())) {
          this.submitButtons.forEach((button) => (button.disabled = false));
          return;
        }
        window.location.href = after === 'checkout' ? '/checkout' : this.dataset.cartUrl || '/cart';
      } catch (err) {
        this.submitButtons.forEach((button) => (button.disabled = false));
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        }
      }
    }

    initGallery() {
      const gallery = this.querySelector('[data-gallery]');
      const thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      if (!gallery || !thumbs.length) return;
      const slides = Array.from(gallery.children);
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const slide = slides[Number(thumb.dataset.thumb)];
          if (slide) gallery.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        });
      });
      let frame;
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const position = gallery.scrollLeft + slides[0].offsetLeft;
          let index = 0;
          slides.forEach((slide, i) => {
            if (Math.abs(slide.offsetLeft - position) < Math.abs(slides[index].offsetLeft - position)) index = i;
          });
          thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
        });
      }, { passive: true });
    }

    initSticky() {
      const sticky = this.querySelector('[data-sticky]');
      const submit = this.querySelector('[data-submit]');
      if (!sticky || !submit || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting;
      }).observe(submit);
    }

    initShipDate() {
      const el = this.querySelector('[data-ships]');
      if (!el || !el.dataset.template) return;
      const date = new Date();
      let days = Number(this.dataset.shipDays || 1);
      while (days > 0) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) days -= 1;
      }
      while (date.getDay() === 0 || date.getDay() === 6) date.setDate(date.getDate() + 1);
      const label = date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      el.textContent = el.dataset.template.replace('[date]', label);
    }

    initCountdown() {
      const el = this.querySelector('[data-countdown]');
      if (!el) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const now = new Date();
        const end = new Date(now);
        end.setHours(24, 0, 0, 0);
        const left = Math.max(0, Math.floor((end - now) / 1000));
        el.textContent = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  if (!customElements.get('mp-buy-box')) customElements.define('mp-buy-box', MpBuyBox);

  } catch(e) { console.error(e); }
})();
})();
